import { render, staticRenderFns } from "./tabPelanggaran.vue?vue&type=template&id=237cf7ef"
import script from "./tabPelanggaran.vue?vue&type=script&lang=js"
export * from "./tabPelanggaran.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports